<script type="text/babel">
import ManagesModalState from 'dashboard-js/mixins/ManagesModalState'
import NavigationProvider from 'dashboard-js/providers/NavigationProvider'
import RestoreOnPageBack from 'dashboard-js/mixins/RestoreOnPageBack'

export default {
    mixins: [ManagesModalState, RestoreOnPageBack],
    props: ['user', 'brand'],

    methods: {
        accountDeposited() {
            this.closeModal()

            NavigationProvider.reload()
        },
    },
}
</script>
